import axios from "axios";
import store from "../store/index.js";
import { Environment } from "./Environment";

const instance = axios.create({
  baseURL: Environment.get("VUE_APP_API2_HOST") + "/api/",
  timeout: 10000,
  headers: {
    authorization: "Bearer " + localStorage.tablet_token,
  },
  params: {},
  //withCredentials: true
});

/* Safe this if you want to use this for later
instance.interceptors.request.use((config) => {
    console.log('Hola, request!')
    return config;
}, (error) => {
    console.log('Hola, response error!!!!', error)
    return Promise.reject(error);
});
*/

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getBackoffDelay(retryCount, base = 300) {
  const jitter = Math.floor(Math.random() * 100);
  return Math.min(10000, base * 2 ** retryCount + jitter);
}

// Only retry on these
const RETRYABLE_STATUSES = [502, 503, 504];
const MAX_RETRIES = 3;

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const config = error.config;
    if (!config || config._retryCount >= MAX_RETRIES) {
      return Promise.reject(error);
    }

    const status = error.response?.status;

    // Only retry on network error or specific 5xx codes
    const shouldRetry = !status || RETRYABLE_STATUSES.includes(status);

    if (!shouldRetry) {
      if (error.response && error.response.status === 401) {
        store.dispatch("setToken", null);
        store.dispatch("setUser", null);
        localStorage.removeItem("token");
        // window.location = "/login?to=admin"; //We dont need this now that we have a login on each app
        console.log("Token expired, user logged out");
      }
      return Promise.reject(error);
    }

    config._retryCount = (config._retryCount || 0) + 1;

    // Clear ALB cookie (only on retryable server errors)
    document.cookie = "AWSALB=; Max-Age=0; path=/";
    document.cookie = "AWSALBTG=; Max-Age=0; path=/";

    const backoff = getBackoffDelay(config._retryCount);
    console.log(
      `Api Retry #${config._retryCount} after ${backoff}ms for status ${
        status || "network error"
      }`
    );

    await delay(backoff);
    return instance(config);
  }
);

export default () => {
  return instance;
};
